import { memo } from "react";
import Box from "@mui/material/Box";
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import { RoleName } from "consts/auth";
import { WebRoutes } from "consts/enpoints/web";
import Resource from 'ui/layouts/Resource';
import { whereUserRole } from "features/onboarding/helpers";
import ApplicationSummary from "./ApplicationSummary";

const Applications = () => (
    <Resource
        breadcrumbsProps={{
            heading: 'Onboarding',
            links: [
                {
                    name: 'Merchant Applications'
                }
            ]
        }}
    >
        <Box
            sx={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
                gap: 2
            }}
        >
            <ApplicationSummary
                whereUserRole={whereUserRole(RoleName.OnboardingE)}
                slotProps={{
                    header: {
                        title: 'E-Commerce',
                        avatar: (
                            <WorkspacePremiumIcon />
                        )
                    },
                    link: {
                        href: WebRoutes.Onboarding.Applications.ECommerce,
                        children: 'Go to E-Commerce Applications',
                    }
                }}
            />
            <ApplicationSummary
                whereUserRole={whereUserRole(RoleName.OnboardingO)}
                slotProps={{
                    header: {
                        title: 'High-Risk',
                        avatar: (
                            <PriorityHighIcon />
                        )
                    },
                    link: {
                        href: WebRoutes.Onboarding.Applications.HighRisk,
                        children: 'Go to High-Risk Applications',
                    }
                }}
            />
        </Box>
    </Resource>
);

export default memo(Applications);
